import { css } from "@emotion/react";

export const rowStore = css`
  display: flex;
  justify-content: space-between;

  a {
    width: calc(50% - 4px);
    > span {
      width: 100%;
      button {
        width: 100%;
        padding: 0;
        img {
          margin-right: 6px;
        }
        span {
          font-size: 15px;
          color: var(--gray-600);
        }
      }
    }
  }
`;
